<button mat-raised-button  *appRole="['TiposPunitorio.Crear']" color="primary" [routerLink]="['/tipospunitorio']">
    <mat-icon>add</mat-icon>
    Nueva tipo punitorio
</button>
